<template>
  <v-layout column>
    <v-master-detail-pane :selected="selectedLoad"
                          @reset="selectLoad(null)">

      <template slot="master">
        <v-load-nav-list :search-prompt="`Search ${loads.length} loads`"
                         title="Monthly Loads"
                         :accurate-since="loadsAccurateSince"
                         :loads="filteredLoads"
                         :customerLoads="groupedBySponsorLoads"
                         :carrierLoads="groupedByCarrierLoads"
                         :loading="loading"
                         history

                         @update:searchTerm="search = $event"
                         @loadMonth="$emit('selectMonth', $event)"
                         @selectMonth="$emit('selectMonth', $event)">
          <template slot="subheader">
            <v-subheader class="sort-btn" @click="toggleSort()">
              <v-icon class="pr-2" color="primary">
                {{ 'play_for_work' }}
              </v-icon>
              <span>Delivery/Cancellation</span>

              <v-spacer/>
              <v-icon color="accent" class="pl-3">
                event
              </v-icon>
              <v-icon v-if="sortDesc"
                      color="accent">
                arrow_drop_down
              </v-icon>
              <v-icon v-else
                      color="accent">
                arrow_drop_up
              </v-icon>
            </v-subheader>
          </template>

          <template slot="loadTile"
                    slot-scope="{ idx, load: archive }">
            <v-list-tile :key="`unassigned_load_${idx}_${archive.load.listingHumanId}`"
                         @click="selectLoad(archive.load)"
                         :class="{'primary lighten-1': isSelectedLoad(archive.load)}"
                         :inactive="isSelectedLoad(archive.load)"
                         ripple avatar>

              <v-list-tile-content>
                <v-list-tile-title>{{ loadModel.loadNickname(archive.load, ) || _.get(archive.load, 'sponsor.name', '...') }}</v-list-tile-title>
                <v-list-tile-sub-title class="text--primary">
                  {{ archive.load.humanId }}: {{ (archive.delivered || archive.archived) | formatShortDate }}
                </v-list-tile-sub-title>
                <v-list-tile-sub-title>
                  {{loadModel.haulingCompany(archive.load).name}} <span v-if="archive.load.tacticalInfo.assignedTruckingCompanyDriverName">, {{archive.load.tacticalInfo.assignedTruckingCompanyDriverName}}</span>
                  <span v-if="_.get(archive.load, 'terms.customerSettlement', false)">, ${{ archive.load.terms.customerSettlement.amount }}</span>
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-chip color="primary"
                        text-color="white" small>
                  <v-icon>{{ archiveStatusIcon(archive) }}</v-icon>
                </v-chip>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider :key="`unassigned_divider_${idx}_${archive.load.listingHumanId}`"/>
          </template>

          <template slot="customerLoadsTile" slot-scope="{ idx, loads: archives, sponsor }">
            <v-list-group :key="`groupedBy_${idx}`">
              <v-list-tile slot="activator">
                <v-list-tile-action>
                  <v-chip color="green"
                          text-color="white" small>
                    {{ archives.length }}
                  </v-chip>
                </v-list-tile-action>
                <v-list-tile-title>{{ sponsor }}</v-list-tile-title>
              </v-list-tile>
              <template v-for="archive in archives" >
                <v-list-tile :key="`grouped_load_${archive.load.humanId}`"
                             @click="selectLoad(archive.load)"
                             :class="{'primary lighten-1': isSelectedLoad(archive.load)}"
                             :inactive="isSelectedLoad(archive.load)"
                             ripple avatar>
                  <v-list-tile-content>
                    <v-list-tile-title v-if="loadModel.loadNickname(archive.load, )">{{ loadModel.loadNickname(archive.load, ) }}</v-list-tile-title>
                    <v-list-tile-sub-title class="text--primary">
                      {{ archive.load.humanId }}: {{ (archive.delivered || archive.archived) | formatShortDate }}
                    </v-list-tile-sub-title>
                    <v-list-tile-sub-title>
                      {{loadModel.haulingCompany(archive.load).name}}<span v-if="archive.load.tacticalInfo.assignedTruckingCompanyDriverName">, {{archive.load.tacticalInfo.assignedTruckingCompanyDriverName}}</span>
                      <span v-if="_.get(archive.load, 'terms.customerSettlement', false)">, ${{ archive.load.terms.customerSettlement.amount }}</span>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-chip color="primary"
                            text-color="white" small>
                      <v-icon>{{ archiveStatusIcon(archive) }}</v-icon>
                    </v-chip>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider :key="`load_divider_${archive.load.humanId}`"/>
              </template>
            </v-list-group>
          </template>

          <template slot="carrierLoadsTile" slot-scope="{ idx, loads: archives, carrier }">
            <v-list-group :key="`groupedBy_${idx}`">
              <v-list-tile slot="activator">
                <v-list-tile-action>
                  <v-chip color="accent"
                          text-color="white" small>
                    {{ archives.length }}
                  </v-chip>
                </v-list-tile-action>
                <v-list-tile-title>{{ carrier }}</v-list-tile-title>
              </v-list-tile>
              <template v-for="archive in archives" >
                <v-list-tile :key="`grouped_load_${archive.load.humanId}`"
                             @click="selectLoad(archive.load)"
                             :class="{'primary lighten-1': isSelectedLoad(archive.load)}"
                             :inactive="isSelectedLoad(archive.load)"
                             ripple avatar>
                  <v-list-tile-content>
                    <v-list-tile-title v-if="loadModel.loadNickname(archive.load, )">{{ loadModel.loadNickname(archive.load, ) }}</v-list-tile-title>
                    <v-list-tile-sub-title class="text--primary">
                      {{ archive.load.humanId }}: {{ (archive.delivered || archive.archived) | formatShortDate }}
                    </v-list-tile-sub-title>
                    <v-list-tile-sub-title>
                      {{archive.load.sponsor.name}}<span v-if="archive.load.tacticalInfo.assignedTruckingCompanyDriverName">, {{archive.load.tacticalInfo.assignedTruckingCompanyDriverName}}</span>
                      <span v-if="_.get(archive, 'load.terms.customerSettlement', false)">, ${{ archive.load.terms.customerSettlement.amount }}</span>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-chip color="primary"
                            text-color="white" small>
                      <v-icon>{{ archiveStatusIcon(archive) }}</v-icon>
                    </v-chip>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider :key="`load_divider_${archive.load.humanId}`"/>
              </template>
            </v-list-group>
          </template>
        </v-load-nav-list>
      </template>

      <template slot="detail">
        <load-detail :currentLoad="selectedLoad" v-if="selectedLoad"
                     :company="company"
                     @refreshLoad="refreshSelectedLoad()">
        </load-detail>
      </template>
    </v-master-detail-pane>
  </v-layout>
</template>

<script>
import _ from 'lodash';
import API from '@/api';
import moment from 'moment';
import { mapState, mapGetters } from 'vuex';
import Model from '@/types/models/';
import companyNamesMixin from '@/mixins/companyNames';
import IconBase from '@/components/IconBase';
import EmptyState from '@/components/EmptyState';
import IconCold from '@/components/icons/IconCold';
import IconHose from '@/components/icons/IconHose';
import IconWood from '@/components/icons/IconWood';
import IconPdf from '@/components/icons/IconPDF';
import VLoadNavList from '@/components/dashboard/simple/LoadNavList';
import LoadDetail from '@/components/dashboard/simple/LoadDetail';
import VMasterDetailPane from '@/components/MasterDetailPane';
import * as Checks from '@/store/permissions';
import * as Loads from '@/types/models/load';
import { loadStatus } from '@/types';
import * as types from '@/store/mutationTypes';
import LoadDistance from '@/components/InfoWidgets/LoadDistance';
import SelectDriver from '@/components/SelectDriver';
import UpdateEtaDialog from '@/components/modals/UpdateEtaDialog';

export default {
  name: 'MonthHistoryLoads',
  mixins: [companyNamesMixin],
  components: {
    UpdateEtaDialog,
    SelectDriver,
    LoadDistance,
    EmptyState,
    IconBase,
    IconHose,
    IconWood,
    IconCold,
    IconPdf,
    VLoadNavList,
    LoadDetail,
    VMasterDetailPane,
  },
  props: {
    company: {
      type: Object,
      default() {
        return {};
      },
    },
    loads: {
      required: true,
      type: Array,
    },
    viewedLoad: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    accurateSince: {
      type: Object, // moment
      default: null,
    },
  },
  data: () => ({
    sortDesc: true,
    selectedLoad: null,
    checkinBtnLoading: false,
    loadingProfile: false,
    search: '',
    pagination: {
      sortBy: null,
      descending: true,
    },
    status: 'Month History',
  }),
  computed: {
    ...mapState('applications', {
      appLoading: 'loading',
    }),
    ...mapState('profiles', {
      userProfile: 'userProfile',
    }),
    ...mapGetters('profiles', {
      isLtnAdmin: 'isLtnAdmin',
    }),
    ...mapGetters('bookedLoads', {
      bookedLoadsTime: 'timestamp',
    }),
    _() {
      return _;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    loadStatus() {
      return loadStatus;
    },
    statusName() {
      let name;
      switch (this.status) {
        case loadStatus.IN_TRANSIT:
          name = 'In Transit';
          break;
        case loadStatus.SCHEDULED:
          name = 'Scheduled';
          break;
        case loadStatus.DELIVERED:
          name = 'Delivered';
          break;
        default:
          name = '';
      }
      return name;
    },
    groupedBySponsorLoads() {
      const nameSorted = _.sortBy(this.filteredLoads, archive => _.get(archive, 'load.sponsor.name', ''));
      return _.groupBy(nameSorted, archive => _.get(archive, 'load.sponsor.name', ''));
    },
    groupedByCarrierLoads() {
      const nameSorted = _.sortBy(this.filteredLoads, archive => _.get(Model.load.haulingCompany(archive.load), 'name', ''));
      return _.groupBy(nameSorted, archive => _.get(Model.load.haulingCompany(archive.load), 'name', ''));
    },
    loadsAccurateSince() {
      if (this.loading) {
        return 'Loading ...';
      }

      if (this.accurateSince) {
        return `Updated ${this.$options.filters.formatTimeStamp(this.accurateSince)}`;
      }
      return '';
    },
    filteredLoads() {
      const filtered = this.filterLoads(this.loads, this.search, this.filter);

      const sort = this.sortDesc ? 'desc' : 'asc';
      return _.orderBy(filtered, [archive =>
        moment((archive.delivered || archive.archived), moment.ISO_8601).unix()], [sort]);
    },
    loadModel() {
      return Model.load;
    },
  },
  methods: {
    ...mapGetters('profiles', {
      findCompanyAccount: 'findCompanyAccount',
    }),
    selectLoad(load) {
      this.selectedLoad = load;
    },
    async refreshSelectedLoad() {
      this.$store.commit(`applications/${types.START_LOADING}`);
      const apiResponse = await API.load.getLoad({ loadId: this.selectedLoad.humanId });
      this.$store.dispatch('bookedLoads/updateLoad', apiResponse.data);
      this.selectedLoad = apiResponse.data;
      this.$store.commit(`applications/${types.END_LOADING}`);
    },
    isSelectedLoad(load) {
      return load.humanId === _.get(this.selectedLoad, 'humanId', null);
    },
    archiveStatusIcon(archive) {
      const status = archive.closingStatus;
      if (this.hasBeenCanceled(archive.load)) {
        return 'cancel';
      } else if (archive.closingStatus === loadStatus.SETTLEMENT) {
        return 'attach_money';
      } else if (loadStatus.SCHEDULED === status) {
        return 'schedule';
      } else if (loadStatus.IN_TRANSIT === status) {
        return 'local_shipping';
      } else if (loadStatus.DELIVERED === status) {
        return 'done';
      }

      return 'money';
    },
    toggleSort() {
      this.sortDesc = !this.sortDesc;
    },
    refreshBookedLoads() {
      this.$store.dispatch('bookedLoads/getBookedLoads', this.company.id);
    },
    normalizeLoads(loads) {
      _.forEach(loads, (archive) => {
        // eslint-disable-next-line no-param-reassign
        archive.load.sponsor = archive.load.tacticalInfo.loadDetails.customerCompany || archive.load.tacticalInfo.loadDetails.listingCompany;
        // eslint-disable-next-line no-param-reassign
        archive.load.pickupTime = archive.load.tacticalInfo.estimatedPickup || archive.load.tacticalInfo.scheduledPickupTime;
        // eslint-disable-next-line no-param-reassign
        archive.load.deliveryTime = _.get(archive.load, 'tacticalInfo.delivery.when', false) || archive.load.tacticalInfo.estimatedDelivery;
      });

      return loads;
    },
    filterLoads(items, searchString, filter) {
      const search = searchString.toString().toLowerCase();
      this.$ga.event({
        eventCategory: 'search',
        eventAction: 'search-load',
        eventLabel: search,
      });

      window.__insp.push(['tagSession', 'search_booked_loads']);
      return items.filter(archive =>
        filter(_.get(archive, 'load.humanId', ''), search) ||
        filter(_.get(archive, 'load.sponsor.name', ''), search) ||
        filter(this.loadModel.billOfLadingNumber(archive.load), search) ||
        filter(_.get(this.loadModel.listingCompany(archive.load), 'name', ''), search) ||
        filter(_.get(this.loadModel.loadNickname(archive.load), 'name', ''), search) ||
        filter(_.get(this.loadModel.haulingCompany(archive.load), 'name', ''), search) ||
        filter(_.get(this.loadModel.pickupCompany(archive.load), 'name', ''), search) ||
        filter(_.get(this.loadModel.pickupLocationChute(archive.load), 'companyName', ''), search) ||
        filter(_.get(this.loadModel.pickupLocationChute(archive.load), 'label', ''), search) ||
        filter(_.get(this.loadModel.pickupLocationGooglePlace(archive.load), 'placeName', ''), search) ||
        filter(_.get(this.loadModel.pickupLocationGooglePlace(archive.load), 'formattedAddress', ''), search) ||
        filter(_.get(this.loadModel.dropoffCompany(archive.load), 'name', ''), search) ||
        filter(_.get(this.loadModel.dropoffLocationChute(archive.load), 'companyName', ''), search) ||
        filter(_.get(this.loadModel.dropoffLocationChute(archive.load), 'label', ''), search) ||
        filter(_.get(this.loadModel.dropoffLocationGooglePlace(archive.load), 'placeName', ''), search) ||
        filter(_.get(this.loadModel.dropoffLocationGooglePlace(archive.load), 'formattedAddress', ''), search) ||
        filter(this.loadModel.assignedTruckingCompanyDriverName(archive.load), search));
    },
    filter(val, search) {
      return val != null && typeof val !== 'boolean' && val.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1;
    },
    w9Link(load) {
      return _.get(Model.load.carrierCompany(load), 'truckingInfo.w9Url', null);
    },
    async openW9File(load) {
      this.$store.commit(`applications/${types.START_LOADING}`);
      const response = await API.application.getDocument({ url: this.w9Link(load) });
      const url = window.URL.createObjectURL(response);
      window.open(url, '_self');
      this.$store.commit(`applications/${types.END_LOADING}`);
    },
    sortLoads(items, index, isDescending) {
      let sortedItems;
      switch (index) {
        case 'loaded-miles':
          sortedItems = _.sortBy(items, [load => _.get(load, 'tacticalInfo.loadDetails.loadedMiles', 0)]);
          break;
        case 'load-id':
          sortedItems = _.sortBy(items, [load => load.humanId]);
          break;
        case 'load-times':
          sortedItems = _.sortBy(items, [load =>
            moment(Model.load.notificationDeliveryTime(load).dateObject,
              moment.ISO_8601).unix()]);
          break;
        case 'carrier':
          sortedItems = _.sortBy(items, [load => Model.load.haulingCompany(load).name]);
          break;
        default:
          sortedItems = items;
      }

      this.$ga.event({
        eventCategory: 'sort',
        eventAction: 'sort-load',
        eventLabel: index,
      });

      localStorage.setItem('desktopLoadSortBy', index);

      if (isDescending) {
        sortedItems.reverse();

        localStorage.setItem('desktopLoadDescending', 'true');
      } else {
        localStorage.removeItem('desktopLoadDescending');
      }

      return sortedItems;
    },
    async checkIn(loadId) {
      this.checkinBtnLoading = true;
      try {
        const userPosition = await API.map.getUserPosition();
        await API.load.checkIn({
          loadId,
          lat: _.get(userPosition, 'latitude', null),
          lng: _.get(userPosition, 'longitude', null),
          timestamp: new Date().toISOString(),
        });
        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Checked In successfully!',
        });
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.checkinBtnLoading = false;
      }
    },
    viewLoadDetail(load) {
      const loadId = _.get(load, 'humanId');
      this.$router.push(`/loads/${loadId}/detail`);
    },
    billOfLadingNumber(load) {
      return Loads.billOfLadingNumber(load);
    },
    listingCompany(load) {
      return Loads.listingCompany(load);
    },
    pickupLocation(load) {
      return Loads.pickupLocation(load);
    },
    dropoffLocation(load) {
      return Loads.dropoffLocation(load);
    },
    loadDetails(load) {
      return Loads.listingDetails(load);
    },
    driverId(load) {
      return Loads.assignedTruckingCompanyDriverUserId(load);
    },
    driverName(load) {
      return Loads.assignedTruckingCompanyDriverName(load);
    },
    hasOfficePermission(companyId) {
      const companyAccount = this.findCompanyAccount()(companyId);
      return this.isLtnAdmin || Checks.accountHasOfficePermission(companyAccount);
    },
    isDriver(load) {
      return Loads.isDriver(this.userProfile, load);
    },
    hasAssignedDriver(load) {
      return Loads.assignedTruckingCompanyDriverUserId(load);
    },
    isCarrierParticipant(load) {
      return this.isDriver(load) ||
             this.isLtnAdmin ||
             (Loads.carrierCompany(load) && this.hasOfficePermission(Loads.carrierCompany(load).id));
    },
    expandRow(slotItems) {
      // eslint-disable-next-line no-param-reassign
      slotItems.expanded = !slotItems.expanded;

      const listingCompanyId = this.loadModel.listingCompany(slotItems.item).id;
      if (slotItems.expanded &&
        this.hasBeenDelivered(slotItems.item) &&
        this.hasOfficePermission(listingCompanyId)) {
        this.loadingProfile = true;
        API.company.byId({ id: listingCompanyId }).then((companyProfile) => {
          this.loadingProfile = false;
          // eslint-disable-next-line no-param-reassign
          slotItems.item.billingAddress = _.get(companyProfile, 'data.producerInfo.billingAddress', {});
        });
      }
    },
    shouldShowRowExpandSlot(load) {
      const isProducerOffice = this.hasOfficePermission(Loads.listingCompany(load).id);
      const hasBillOfLadingNumber = this.billOfLadingNumber(load);
      return this.isLtnAdmin ||
        this.isCarrierParticipant(load) ||
        (isProducerOffice && hasBillOfLadingNumber);
    },
    isUnassigned(load) {
      const carrier = this.loadModel.carrierCompany(load);
      return carrier && this.hasOfficePermission(carrier.id)
        && !this.hasAssignedDriver(load);
    },
    isAssigned(load) {
      const carrier = this.loadModel.carrierCompany(load);
      return carrier && this.hasOfficePermission(carrier.id)
        && this.hasAssignedDriver(load);
    },
    hasBeenCanceled(load) {
      return load.loadStatus === loadStatus.CANCELED;
    },
    hasBeenDelivered(load) {
      return load.loadStatus === loadStatus.DELIVERED ||
             load.loadStatus === loadStatus.FINALIZED;
    },
    viewBillOfLading(load) {
      this.$store.dispatch('lightbox/show', load.billOfLading.link);
    },
  },
  filters: {
    formatTimeStamp(momentDate) {
      return momentDate.format('HH:mm A MMM DD');
    },
  },
  watch: {
    loads(newVal, oldVal) {
      this.normalizeLoads(newVal);
    },
  },
  created() {
    const sortingValue = localStorage.getItem('desktopLoadSortBy');
    const descending = localStorage.getItem('desktopLoadDescending');
    if (sortingValue) {
      this.$set(this.pagination, 'sortBy', sortingValue);
      this.$set(this.pagination, 'descending', !!descending);
    }

    this.normalizeLoads(this.loads);

    if (this.viewedLoad) {
      this.selectLoad = this.viewedLoad;
    }
  },
};
</script>

<style scoped>
  .pickup-col {
    width: 200px;
  }

  .id-col {
    position: relative;
    padding-left: 35px !important;
  }

  .expand-icon {
    position: absolute;
    left: 5px;
    top: auto;
    bottom: auto;
    margin-top: 10px;
  }

  .miles-col {
    width: 200px;
  }

  .unassigned {
    border-left: 3px red solid;
  }

  .assigned {
    border-left: 3px #428BCA solid;
  }
</style>

<style>
  .load-id-header {
    padding-left: 35px !important;
  }

  .sort-btn {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/simple/MonthHistoryLoads.vue